import React, {FC, useState} from 'react';
import { DirectoryBar } from '../components/DirectoryBar';
import NewLineText from '../common/NewLineText';
import TERMS_TEXT from '../constants/terms';
export const Terms = () => {
    return (
        <>
            <DirectoryBar text="홈, 이용약관" />
            <div className="max-w-2xl m-auto text-left pb-20">
                <br/><h2>서비스 이용 약관</h2><br/>
                <NewLineText text={TERMS_TEXT} />
            </div>
        </>
    );
};

